import { IColumnFilter } from "../../models/IColumnFilter";

export class OrderBlotterState {
  columnFilters: IColumnFilter[] = [];
}
